class PlanQuizResults extends HTMLElement {
  constructor() {
    super();

    this.usage = this.querySelector('[data-usage]');
    this.plans = [...this.querySelectorAll('[data-plan]')].sort((a, b) => {
      const aLimit = parseInt(a.dataset.limit, 10);
      const bLimit = parseInt(b.dataset.limit, 10);
      return aLimit - bLimit;
    });
  }

  update(usage) {
    // Hide all plans initially
    this.plans.forEach((plan) => {
      plan.classList.add('hidden');
    });

    // Update the usage text
    const usageLabel = Math.max(usage, 12);
    this.usage.textContent = `${usageLabel}GB`;

    // Find the plan that matches the usage
    const plan = this.plans.find((plan) => {
      const limit = parseInt(plan.dataset.limit, 10);
      return usage <= limit;
    });

    // If no plan matches, recommend the last plan
    const recommend = plan || this.plans[this.plans.length - 1];

    // Show the recommended plan
    recommend.classList.remove('hidden');
  }
}

customElements.define('plan-quiz-results', PlanQuizResults);
